import React, { useContext, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { makeStyles } from '@mui/styles';
import { Header } from '../../components/Header';
import TabPlace from './components/TabPlace';
import TabServices from './components/TabServices/TabServices';
import TabToppings from './components/TabToppings/TabToppings';
import TabMenu from './components/TabMenu/TabMenu';
import { PlaceStoreContext } from '../../reducers/Place/PlaceContext';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#ffffff',
    color: '#000000',
    boxShadow: 'none',
    justifyContent: 'center',
  },
  tab: {
    fontSize: window.innerWidth < 450 ? '0.6rem' : '0.7rem',
    fontWeight: 'bold',
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const EditMenuPage = () => {
  const [placeState] = useContext(PlaceStoreContext);

  const classes = useStyles();
  const history = useHistory();

  const [tab, setTab] = React.useState(history.location.pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!placeState.initialized) {
    return null;
  }

  const handleCallToRouter = (event, newTab) => {
    history.push(newTab);
    setTab(newTab);
  };

  return (
    <div style={{ marginTop: '60px' }}>
      <Header route="Menu Management" />
      <AppBar position="static" elevation={0}>
        <Tabs
          value={history.location.pathname}
          onChange={handleCallToRouter}
          aria-label="menu-management"
          className={classes.root}
          centered
        >
          <Tab label="Place" value="/manage/place" {...a11yProps(0)} />
          <Tab label="Homepage" value="/manage/services" {...a11yProps(1)} />
          <Tab label="Menu" value="/manage/menu" {...a11yProps(2)} />
          <Tab label="Extras" value="/manage/extras" {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <TabPanel value={tab} index={'/manage/place'}>
        <TabPlace />
      </TabPanel>
      <TabPanel value={tab} index={'/manage/services'}>
        <TabServices />
      </TabPanel>
      <TabPanel value={tab} index={'/manage/menu'}>
        <TabMenu />
      </TabPanel>
      <TabPanel value={tab} index={'/manage/extras'}>
        <TabToppings />
      </TabPanel>
    </div>
  );
};

export default EditMenuPage;
